import React, { useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Popper } from '@mui/material';
import { useCommands } from '@remirror/react';

export const ImageInputDialog = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [url, setUrl] = useState<string>('');
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const { insertImage } = useCommands();

  const toggleDialog = (event: React.MouseEvent<HTMLElement>) => {
    setIsDialogOpen((prev) => !prev);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleOnSubmit = () => {
    insertImage({ src: url });
    setUrl('');
    setIsDialogOpen(false);
    setAnchorEl(null);
  };

  const handleCancel = () => {
    setUrl('');
    setIsDialogOpen(false);
    setAnchorEl(null);
  };

  return (
    <div>
      <button onClick={toggleDialog} type="button">
        <FontAwesomeIcon className={'fa-regular fa-image'} />
      </button>

      <Popper
        open={isDialogOpen}
        anchorEl={anchorEl}
        placement="bottom-start"
        className="z-1000"
      >
        <div className="bg-white shadow-lg border rounded p-4 w-64">
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleOnSubmit();
              }
              if (e.key === 'Escape') {
                handleCancel();
              }
            }}
            placeholder="Type here..."
            className="w-full border rounded px-2 py-1 mb-2"
            autoFocus
          />
          <div className="flex justify-end gap-2">
            <button
              onClick={handleCancel}
              className="px-3 py-1 text-sm bg-gray-200 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handleOnSubmit}
              className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
            >
              Submit
            </button>
          </div>
        </div>
      </Popper>
    </div>
  );
};
